import React, { useRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { GetGamePoster } from "../ScrollableListView";
import { Link } from "react-router-dom";
import { AsyncImage } from "loadable-image";
import { useParams } from "react-router-dom";
import i18n from "i18n";
import { IoPlayCircleOutline } from "react-icons/io5";
import { Translation } from "react-i18next";
import { oranHesapla } from "./BLAS975GameBox";
import toast from "react-hot-toast";
import { isBrowser, isMobile } from "react-device-detect";

const DigitalOceanSpacesBox = (props) => {
  const containerRef = useRef(null);
  const [H, setH] = useState(null);
  const { item, index, isLive, provider, mainCat } = props;
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  let params = GetParams();

  function GetParams() {
    let params = useParams();
    return params;
  }

  const resizeBox = () => {
    if (containerRef && containerRef.current) {
      const w = containerRef.current?.clientWidth;
      const prgmaticName = document.querySelector(".detroitName")?.offsetHeight;

      const nW = oranHesapla(350, 261, w);
      containerRef.current.style.height = `${nW + prgmaticName}px`;

      setH(`${w + prgmaticName}px`);
    }
  };
  useEffect(() => {
    window.addEventListener("DOMContentLoaded", resizeBox);
    window.addEventListener("resize", resizeBox);
  }, []);
  debugger
  return (
    <Translation>
      {(t) => (
        <>
          <div
            ref={containerRef}
            key={item.gamecode + item.System}
            className="GameBox h-[143px] md:h-[220px]  bg-primary-500 md:bg-secondary-500 group/item cursor-pointer md:border md:border-primary-500"
            onLoad={() => resizeBox()}
            style={{
              height: H ? H : undefined,
            }}
          >
            <div className="games-img">
              <AsyncImage
                className="h-full w-full rounded-t-[2.5vw] md:rounded-t-md"
                id={"detroit-poster" + item.id}
                src={item.media}
                alt={item.name}
                loader={
                  <div className="skeleton w-full h-full bg-secondary-500">
                    <img
                      src={require("../../../assets/img/logotexttans.png")}
                    ></img>
                  </div>
                }
                error={
                  <div className="bg-light-500">
                    <img
                      src={require("../../../assets/img/logotexttans.png")}
                    ></img>
                  </div>
                }
              />
            </div>
            <div className="game-hover group-hover/item:before:opacity-80"></div>
            {isLive && (
              <div
                style={{ position: "absolute" }}
                id={"detroit" + item.gamecode}
                className="games-img "
              >
                <span
                  id={"detroit-account" + item.gamecode}
                  className="game-live-limitbet-account opacity-[0] bg-primary-500/80"
                ></span>
                <span
                  id={"detroit-limitbet" + item.gamecode}
                  className="game-live-limitbet opacity-[0]  bg-primary-500/80"
                ></span>
              </div>
            )}

            {!item?.currencies?.find((x) => x == props.user.Currency) ? (
              <div
                onClick={() => {
                  toast.error(t("ERROR_CAN_NOT_PLAY_CURRENCY"));
                }}
                className="game-btns   flex-col px-6"
              >

                <IoPlayCircleOutline className="text-primary-500 w-14 h-14" />
              </div>
            ) : isLive == true ? (
              <Link
                to={`/norok/${provider}/${item.id}`}
                className="game-btns   flex-col px-6"
              >
                <IoPlayCircleOutline className="text-primary-500 w-14 h-14" />
              </Link>
            ) : (
              <div className="game-btns   flex-col  h-full">
                {isMobile ? (
                  item?.device.find((x) => x == "mobile") ? (
                    <>
                      <div className="game-btn-item game-btn-title flex flex-row   justify-start md:justify-center items-center text-[#fff] text-sm px-2 py-0">
                        {item.name}
                      </div>
                      <div className="game-btn-item game-btn-provider flex flex-row   justify-start md:justify-center items-center text-[#b2b2b2] text-xs px-2 pb-1">
                        {item.provider}
                      </div>
                      <Link
                        to={`/norok/${item.provider}/${item.id}`}
                        className="game-btn-item game-btn-play flex flex-row m-1  justify-start md:justify-center items-center text-xs border border-white rounded-md px-2 py-1"
                      >
                        {t("BUTTON_PLAY")}
                      </Link>
                      {item?.modes && item?.modes.find((x) => x == "DEMO") && (
                        <Link
                          to={`/norok/${provider}/${item.gamecode}`}
                          className="game-btn-item game-btn-demo flex flex-row m-1  justify-start md:justify-center items-center  text-xs"
                        >
                          {t("BUTTON_DEMOPLAY")}
                        </Link>
                      )}
                    </>
                  ) : (
                    <div
                      onClick={() => {
                        toast(t("detroit_ERROR_CAN_NOT_PLAY_MOBILE"));
                      }}
                      className="w-full h-full"
                    ></div>
                  )
                ) : item.device.find((x) => x == "desktop") ? (
                  <>
                    <div className="game-btn-item game-btn-title flex flex-row   justify-start md:justify-center items-center text-[#fff] text-sm px-2 py-0">
                      {item.name}
                    </div>
                    <div className="game-btn-item game-btn-provider flex flex-row   justify-start md:justify-center items-center text-[#b2b2b2] text-xs px-2 pb-1">
                      {item.provider}
                    </div>
                    <Link
                      to={`/norok/${item.provider}/${item.id}`}

                      className="game-btn-item game-btn-play flex flex-row m-1  justify-start md:justify-center items-center text-xs border border-white rounded-md px-2 py-1"
                    >
                      {t("BUTTON_PLAY")}
                    </Link>
                    {item?.modes && item?.modes.find((x) => x == "DEMO") && (
                      <Link
                        to={`/detroit-demo/${provider}/${item.gamecode}`}
                        className="game-btn-item game-btn-demo flex flex-row m-1  justify-start md:justify-center items-center"
                      >
                        <IoPlayCircleOutline className="text-primary-500   w-8 h-8    md:w-10 md:h-10 mr-[4px]" />
                        {t("BUTTON_DEMOPLAY")}
                      </Link>
                    )}
                  </>
                ) : (
                  <div
                    onClick={() => {
                      toast(t("ERROR_CAN_NOT_PLAY_DESKTOP"));
                    }}
                    className="game-btns   flex-col px-6 "
                  >

                    <IoPlayCircleOutline className="text-primary-500 w-14 h-14" />
                  </div>
                )}
              </div>
            )}


          </div>
        </>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication } = state;
  const { user } = authentication;

  return {
    user,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DigitalOceanSpacesBox);
